// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GetApp-wrap-zQpgU {
  max-width: 520px;
  margin: 0 auto;
  padding: 80px 24px;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
}
.GetApp-h1-TAt2i {
  font-size: 30px;
  font-weight: 800;
  margin: 0 0 12px;
}
.GetApp-p-M7RIC {
  color: #5a6168;
  font-size: 16px;
  margin: 0 0 26px;
}
.GetApp-badges-Kg_xf {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.GetApp-badge-NbBtL {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: #16a34a;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  padding: 13px 24px;
  border-radius: 12px;
  min-width: 150px;
}
.GetApp-badge-NbBtL:hover {
  background: #0f7a37;
}
`, "",{"version":3,"sources":["webpack://./src/routes/get-app/GetApp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,uFAAuF;EACvF,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".wrap {\n  max-width: 520px;\n  margin: 0 auto;\n  padding: 80px 24px;\n  text-align: center;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: #0f1214;\n}\n.h1 {\n  font-size: 30px;\n  font-weight: 800;\n  margin: 0 0 12px;\n}\n.p {\n  color: #5a6168;\n  font-size: 16px;\n  margin: 0 0 26px;\n}\n.badges {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #16a34a;\n  color: #fff;\n  text-decoration: none;\n  font-weight: 700;\n  padding: 13px 24px;\n  border-radius: 12px;\n  min-width: 150px;\n}\n.badge:hover {\n  background: #0f7a37;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `GetApp-wrap-zQpgU`,
	"h1": `GetApp-h1-TAt2i`,
	"p": `GetApp-p-M7RIC`,
	"badges": `GetApp-badges-Kg_xf`,
	"badge": `GetApp-badge-NbBtL`
};
module.exports = ___CSS_LOADER_EXPORT___;
